import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { User } from '../models/user';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { AppService } from 'src/app/app.service';


@Injectable({
    providedIn: 'root',
})
export class AuthService {
    isLogin = false;
    userID: any;
    appDateFormats: any = {};
    dateAPPFormats: any = []
    monthStartDay: any;
    monthEndDay: any;
    todayDate:any;
    formatsData:any;
    dateFormateApplication : any;
    SelectedOutlet:any='';
    public currentUserSubject: any;
    public currentUser: Observable<User>;
    // tomorrowDate: any = new Date();

    InventoryModuleGiven:boolean=false;
    ExpenseModuleGiven:boolean=false;
    constructor(public http: HttpClient, private snackBar: MatSnackBar,private datePipe: DatePipe,public appservice:AppService) {
        this.currentUserSubject = (JSON.parse(localStorage.getItem('currentUser')));
 
        var nowdate = new Date();
        this.monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1);
        this.monthEndDay = new Date(nowdate.getFullYear(), nowdate.getMonth() + 1, 0);
        this.todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd'); 
        
        // this.tomorrowDate.setDate(this.tomorrowDate.getDate() + 1);    
        // this.tomorrowDate = this.datePipe.transform(new Date(this.tomorrowDate), 'yyyy-MM-dd');     
        
    }

    login(username: string, password: string) {

        let params = {
            Username: username,
            Password: password,
        }
        return this.http.post<any>(`${environment.apiUrl}authenticateUser`, null, { params: params }).pipe(map(resposnse => {
            if (resposnse == "Error") {
                localStorage.setItem('STATE', 'false');
                this.showNotification(
                    'snackbar-danger',
                    'Something went wrong from server side!!!',
                    'bottom',
                    'center'
                );
                return "failure";

            }
            else if (resposnse == "Wrong Credentials") {
                localStorage.setItem('STATE', 'false');
                this.showNotification(
                    'snackbar-danger',
                    'Wrong Credentails!!!',
                    'bottom',
                    'center'
                );
                return "failure";

            }
            else {
                let resp: any = resposnse;
                
                localStorage.setItem('STATE', 'true');
                localStorage.setItem('UserDetails', JSON.stringify(resp));
                this.appservice.InformationAlert('', 'success', 'Confirmation', 'Logged In Successfully!');
               
                    return "success";

            }
        }));



    }


    showNotification(colorName, text, placementFrom, placementAlign) {
        this.snackBar.open(text, '', {
            duration: 2000,
            verticalPosition: placementFrom,
            horizontalPosition: placementAlign,
            panelClass: colorName,
        });
    }

    logout() {

        this.isLogin = false;
        localStorage.clear();
        localStorage.setItem('STATE', 'false');  
        return of({ success: this.isLogin });
    }

    isLoggedIn() {
        const loggedIn = localStorage.getItem('STATE');
        if (loggedIn === 'true') {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
        return this.isLogin;
    }
}
